export enum OrderFileType {
  Confirmation = 'confirmation',
  Invoice = 'invoice',
  Shipping = 'shipping',
  Unidentified = 'unidentified',
}
